//#region Styles
import { 
    Container } from "./styles";
//#endregion
//#region Icons
import ErrorIcon from "icons/ErrorIcon";
//#endregion

const NotifyImportantMessage = ({
    message,
    transparent = false
}) => {
    return (
        <Container className={transparent ? "transparent" : ""}>
            <div>
                <ErrorIcon/>
            </div>
            <p>
                <strong>Importante:</strong> {message}
            </p>
        </Container>
    );
}

export default NotifyImportantMessage;